import { OnInit } from '@angular/core';
import { ButtonViewComponent } from './button-renderer-crypto';

export class EmvoCreatePackRendererCrypto extends ButtonViewComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.renderValue = 'EMVO Create Pack';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/emvo-create-pack-renderer-crypto.ts